export default __webpack_public_path__ + "static/media/flop-equity-rangevsrange_0035_thumb.15e80b35.jpg";